import React from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'

import MetaTags from 'components/meta/MetaTags'
import ScrollTop from 'components/utils/ScrollTop'
import Modal from './Modal'

const ResetPassword = () => {
  const history = useHistory<{ from: string }>()
  const prevPath = history.location?.state?.from
  const fallbackPath = '/login' // If the history has no `from` state return to this path

  const handleClose = () => {
    history.push(prevPath || fallbackPath)
  }

  return (
    <>
      <ScrollTop />
      <MetaTags title="Reset password" />
      <Modal initialRoute="reset_password" open onClose={handleClose} />
    </>
  )
}

export default connect()(ResetPassword)
